module.exports = {"441622100":"老隆镇","441622102":"义都镇","441622103":"佗城镇","441622104":"鹤市镇","441622105":"黄布镇","441622106":"紫市镇","441622107":"通衢镇","441622109":"登云镇","441622110":"丰稔镇","441622111":"四都镇","441622112":"铁场镇","441622114":"龙母镇","441622115":"田心镇","441622116":"黎咀镇","441622117":"黄石镇","441622118":"赤光镇","441622119":"回龙镇","441622120":"新田镇","441622121":"车田镇","441622123":"岩镇镇","441622124":"麻布岗镇","441622125":"贝岭镇","441622126":"细坳镇","441622127":"上坪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441622.json
// module id = 1864
// module chunks = 0